import React from 'react';
import { Flex, Heading, Text } from 'rebass';
import { format } from 'date-fns';
import SkillBox from 'components/SkillBox';
import Link from 'components/Link';
import colors from 'theme/colors';

const JobPostDetails: React.FC<any> = ({ jobPost = {}, companyName }): JSX.Element => {
  const {
    id,
    title,
    country,
    city,
    state,
    type,
    createdAt,
    compensation,
    compensationAsRate,
    skills,
    linkToTest,
    salary,
    requirements,
    responsibilities,
    info,
  } = jobPost;
  return (
    <>
      {!!Object.keys(jobPost).length && (
        <Flex width="100%" flexDirection="column" css="max-width: 990px;" mt={3}>
          <Heading fontSize={['36px']} fontWeight={6} mb={3}>
            {companyName ? `${companyName} - ${title}` : `${title}`}
          </Heading>
          <Flex width="100%" justifyContent="space-between" mb={3}>
            <Flex>
              <Heading as="h3" fontSize={['16px']} mr={1}>
                Posted on:
              </Heading>
              <Text as="p">{format(new Date(createdAt), 'MMM DD, YYYY')}</Text>
            </Flex>
            <Flex>
              <Heading as="h3" fontSize={['16px']} mr={1}>
                Job ID:
              </Heading>
              <Text as="p">{id}</Text>
            </Flex>
            <Flex>
              <Heading as="h3" fontSize={['16px']} mr={1}>
                Position Type:
              </Heading>
              <Text as="p">{type}</Text>
            </Flex>
            <Flex>
              <Heading as="h3" fontSize={['16px']} mr={1}>
                Location:
              </Heading>
              <Text as="p">
                {country}, {city}, {state}
              </Text>
            </Flex>
          </Flex>
          <Flex mb={3}>
            <Text as="p" fontWeight={5} mr={1}>
              Compensation for recruiter:
            </Text>
            <Text as="p">
              {!compensationAsRate && '$'}
              {compensation}
              {compensationAsRate && '%'}
            </Text>
          </Flex>
          <Flex width="100%" mb={3} css="max-width: 370px;">
            {skills &&
              skills.map((skill: string) => (
                <SkillBox key={skill} py={1} px={2} mr={1}>
                  {skill}
                </SkillBox>
              ))}
          </Flex>
          {linkToTest && (
            <Flex mb={3}>
              <Text as="p" fontWeight={5} mr={1}>
                Requires recruiter’s help to admister technical test:
              </Text>
              <Link
                href={linkToTest}
                color={colors.lightGreen}
                hover={colors.lightGreen}
                css="font-weight: 600;"
                target="_blank"
              >
                Link
              </Link>
            </Flex>
          )}
          <Flex mb={3}>
            <Text as="p" fontWeight={5} mr={1}>
              Salary range:
            </Text>
            <Text as="p">
              {salary.min} - {salary.max}$
            </Text>
          </Flex>
          <Flex flexDirection="column" mb={3}>
            <Heading fontSize={['24px']} fontWeight={5} mb={2}>
              Requirements
            </Heading>
            <Text as="p" fontWeight={5}>
              {requirements}
            </Text>
          </Flex>
          <Flex flexDirection="column" mb={3}>
            <Heading fontSize={['24px']} fontWeight={5} mb={2}>
              Responsibilities
            </Heading>
            <Text as="p" fontWeight={5}>
              {responsibilities}
            </Text>
          </Flex>
          <Flex flexDirection="column">
            <Heading fontSize={['24px']} fontWeight={5} mb={2}>
              Additional notes
            </Heading>
            <Text as="p" fontWeight={5}>
              {info}
            </Text>
          </Flex>
        </Flex>
      )}
    </>
  );
};

export default JobPostDetails;
